export default class CurrencyService {
    constructor() {
    }

    formatNumber() {
        let market = $('body').data('lang').toLowerCase();
        let currency = "SEK";

        if (market == "da-dk") {
            currency = "DKK";
        }

        if (market == "nb-no") {
            currency = "NOK";
        }

        if (market == "fi-fi") {
            currency = "EUR";
        }

        $.each($('.format-amount'), function () {
            if (!$(this).hasClass("formatted")) {
                let value = $(this).html().replace(",", ".").replace("kr&nbsp;", "").replace("kr.", "").replace("kr", "").replace("€", "").replaceAll("&nbsp;", "");
                let formatted = new Intl.NumberFormat(market, { style: 'currency', currency: currency }).format(value);

                if (currency == "NOK") {
                    formatted = formatted.replace("kr", "");
                    formatted += " kr";
                }

                $(this).addClass("formatted");

                $(this).html(formatted);
            }
        });
    }
}